import React, { useState, useEffect, useContext } from "react";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";
import { PiFolderSimplePlusFill, PiFoldersFill } from "react-icons/pi";

import { useNavigate } from "react-router-dom";

import Procedures from "./Procedures";
import SOPs from "./SOPs";
import Forms from "./Forms";
import Records from "./Records";

import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";

import { toast } from "react-toastify";
import { MdOutlineDelete, MdOutlineFileDownload } from "react-icons/md";
import { LuFolderEdit } from "react-icons/lu";
import { AiFillDelete } from "react-icons/ai";

import PDF from "../../Components/assets/img/fileplaceholder.png";

import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Typography,
} from "@material-tailwind/react";
import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
import UserContext from "../../context/UserContext";

const Templete = () => {
  const { decryptData } = useEncryption();
  const { setSelectedFolder } = useContext(UserContext);
  const { selectedFolder } = useContext(UserContext);
  const { fileId } = useContext(UserContext);
  const { setFileId } = useContext(UserContext);
  const navigate = useNavigate();

  // const [showInput, setShowInput] = useState(false);
  // const [folderName, setFolderName] = useState("");
  // const [folders, setFolders] = useState([]);

  // const handleClick = () => {
  //   setShowInput(true);
  // };

  // const handleInputChange = (event) => {
  //   setFolderName(event.target.value);
  // };

  // useEffect(() => {
  //   // Load the folders from local storage when the component mounts
  //   const storedFolders = localStorage.getItem("tempaltefolder");
  //   if (storedFolders) {
  //     setFolders(JSON.parse(storedFolders));
  //   }
  // }, []);

  // const handleCreateFolder = () => {
  //   // Create a new folder object with name and date properties
  //   const newFolder = {
  //     name: folderName,
  //   };

  //   // Update folders state with the new folder
  //   setFolders((prevFolders) => [newFolder, ...prevFolders]);

  //   // Reset input and hide it
  //   setFolderName("");
  //   setShowInput(false);

  //   localStorage.setItem(
  //     "tempaltefolder",
  //     JSON.stringify([...folders, newFolder])
  //   );
  // };

  // const [selectedFolder, setSelectedFolder] = useState("Procedures");

  const [activeTab, setActiveTab] = useState(0);
  const [createFolder, setCreateFolder] = React.useState(false); // Folder Creare
  const [renameFolder, setRenameFolder] = React.useState(false); // rename folder
  // console.log("🚀 ~ Templete ~ renameFolder:", renameFolder);
  const [allFolder, setAllFolder] = useState([]); // All folder
  const [allFolderFile, setAllFolderFile] = useState([]); // all folder file

  const [folderId, setFolderId] = useState();
  // console.log("🚀🚀 ~ Templete ~ folderId:", folderId);
  // const [fileId, setFileId] = useState("");

  const [renameNewFolder, setRenameNewFolder] = useState(""); // rename new folder name data
  // console.log("🚀 ~ Templete ~ renameNewFolder:", renameNewFolder);

  const [showModal, setShowModal] = React.useState(false); // Folder Delete popup
  const [showModalFile, setShowModalFile] = React.useState(false); // File Delete popup
  const [getid, setGetid] = useState("");

  // static folder click
  const handleFolderClick = (folderName, id) => {
    setSelectedFolder(folderName);
  };

  // user folder create clik
  const handleCreateFolderClick = (folderName, id) => {
    setSelectedFolder(folderName);
    setFolderId(id);
    setFileId(id);
  };

  const getFolderClass = (folderName) => {
    return selectedFolder === folderName
      ? "bg-[#22345C] text-white  "
      : "bg-white text-[#666666] ";
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const handlePopupClick = (e) => {
    // Stop the event propagation to prevent it from reaching the backdrop
    e.stopPropagation();
  };

  const handleBackdropClick = () => {
    // Close the popup when clicking on the backdrop
    setCreateFolder(false);
    setRenameFolder(false);
  };

  // Get All Folder Show
  const getFolderdata = async () => {
    await axiosInstanceAuth
      .get("/View_folder")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllFolder(myData?.data || []);
        console.log("Folder Data Show---->", myData);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getFolderdata();
  }, []);

  // Add Folder code
  const [folder, setFolder] = useState({
    foldername: "",
  });

  const onChangeInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setFolder({
      ...folder,
      [name]: value,
    });
  };

  const mydata = {
    foldername: folder?.foldername,
  };

  // create folder submit click
  const handleSubmit = async () => {
    await axiosInstanceAuth
      .post("create_folder", mydata)
      .then((res) => {
        const myData = decryptData(res.data.data);
        console.log("User Data ===---===>>>", myData);
        console.log("=========myData", myData);
        if (myData.status) {
          setFolder({
            foldername: "",
          });
          getFolderdata();
          setCreateFolder(false);
          toast.success(myData.message);
        } else {
          toast.error(myData.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };
  const handlerecordClick = (folderName) => {
    if (folderName === "Records") {
      // setSelectedFolder(folderName);
      navigate("/records"); // Adjust the path based on your route configuration
    }
  };
  // Get All Folder File Show
  const getFolderFiledata = async (folderId) => {
    await axiosInstanceAuth
      .get(`view_folder_file/${fileId}`)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        console.log("🚀 ~ .then ~ myData:", myData);
        setAllFolderFile(myData?.data || []);
        setRenameNewFolder(myData.foldername);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    if (fileId) {
      getFolderFiledata(fileId);
    }
  }, [fileId]);

  console.log("🚀 ~ Templete ~ fileId:", fileId);

  // Folder in File Add code
  const [fileUploadData, setFileUploadData] = useState({
    folderfile: "",
  });

  const onChangeInputFile = (e) => {
    const { name } = e.target;
    setFileUploadData({
      ...fileUploadData,
      [name]: e.target.files[0],
    });
  };

  // Folder in file upload submit click
  const handleUploadFile = async (e) => {
    try {
      const formData = new FormData();

      // formData.append("folderfile", fileUploadData?.folderfile);
      formData.append("folderfile", e.target.files[0]);

      axiosInstanceAuthFormData
        .post(`add_folderData/${fileId}`, formData)
        .then((res) => {
          const myData = decryptData(res?.data?.data);
          console.log("__###__#####", myData);
          if (myData?.status) {
            getFolderFiledata();
            toast.success(myData?.message);
          } else {
            toast.error(myData?.message);
          }
        })
        .catch((err) => {
          console.log("------>> Error", err);
        });
    } catch (error) {
      console.error(error);
    }
  };

  // File in view button navigate
  const viewFolderFile = (folderId, selectfileid) => {
    navigate(`/foldertemplatefileshow/${fileId}/${selectfileid}`);
  };

  const renderTabContent = () => {
    if (allFolder.some((folder) => folder.foldername === selectedFolder)) {
      // If the selected folder is a user-created folder, show "Coming soon" message
      return (
        <div className="grid lg:grid-cols-4  grid-cols-2 gap-10 mt-5 mb-5">
          <div className="justify-between items-center text-[#666666] bg-[#FFFFFF] p-5 rounded-[10px] border-gray-400 ">
            <div className="font-sans font-bold text-[#2B2B2B] text-[18px] text-center mb-2">
              Select File
            </div>
            <div className="flex items-center justify-center w-full ">
              <label
                htmlFor="dropzone-file"
                // className="flex flex-col items-center justify-center w-full h-[390px] border-2 border-[#22345C] border-dashed rounded-lg cursor-pointer bg-[#FFFFFF] dark:hover:bg-bray-800 dark:bg-gray-700  dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                className="flex flex-col items-center justify-center w-full h-[390px] border-2 border-[#22345C] border-dashed rounded-lg cursor-pointer bg-[#FFFFFF] "
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    width="63"
                    height="80"
                    viewBox="0 0 63 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M42.8008 0.613833C42.4366 0.230207 41.9374 0 41.4199 0H10.4366C4.71909 0 0 4.70031 0 10.417V69.0068C0 74.724 4.71924 79.4245 10.4364 79.4245H52.4889C58.2062 79.4245 62.9254 74.7242 62.9254 69.0068V22.484C62.9254 21.9854 62.6951 21.506 62.3691 21.1412L42.8008 0.613833ZM43.3571 6.77233L56.4604 20.5275H47.9424C45.41 20.5275 43.3571 18.4938 43.3571 15.9617V6.77233ZM52.4889 75.5876H10.4364C6.84912 75.5876 3.83688 72.6141 3.83688 69.0068V10.417C3.83688 6.82973 6.82973 3.83688 10.4364 3.83688H39.5202V15.9615C39.5202 20.6232 43.2808 24.3644 47.9424 24.3644H59.0884V69.0068C59.0884 72.6141 56.0956 75.5876 52.4889 75.5876Z"
                      fill="#22345C"
                    />
                    <path
                      d="M47.2517 62.3509H15.6738C14.619 62.3509 13.7554 63.2137 13.7554 64.2693C13.7554 65.3242 14.6188 66.1878 15.6738 66.1878H47.2711C48.326 66.1878 49.1895 65.3243 49.1895 64.2693C49.1895 63.2137 48.326 62.3509 47.2517 62.3509ZM21.6401 41.7081L29.5442 33.2089V54.1588C29.5442 55.2137 30.4078 56.0773 31.4627 56.0773C32.5183 56.0773 33.3813 55.2138 33.3813 54.1588V33.2091L41.2854 41.7081C41.6689 42.1105 42.1682 42.3219 42.6857 42.3219C43.1463 42.3219 43.6261 42.1493 43.9903 41.8038C44.7582 41.0749 44.8156 39.866 44.0867 39.0989L32.8444 27.0316C32.4795 26.6482 31.9808 26.418 31.4439 26.418C30.9064 26.418 30.4077 26.6482 30.0436 27.0318L18.8012 39.0989C18.0722 39.866 18.1298 41.0938 18.8969 41.8038C19.7029 42.5329 20.9112 42.4754 21.6401 41.7081Z"
                      fill="#22345C"
                    />
                  </svg>
                </div>
                <input
                  id="dropzone-file"
                  type="file"
                  className="hidden"
                  name="folderfile"
                  onChange={handleUploadFile}
                />
              </label>
            </div>
          </div>

          {allFolderFile?.length > 0 &&
            allFolderFile.map((i, index) => (
              <div
                key={index}
                className="justify-between items-center text-[#666666] bg-[#FFFFFF] p-5 rounded-[10px] border-gray-400 "
              >
                <div className="border-[1.5px] border-black rounded-md p-1">
                  <img src={PDF} alt="" className="w-full h-72" />
                </div>

                <div className="items-center mt-3 text-center h-8 space-y-4">
                  <p className="font-sans font-bold text-[#2B2B2B] text-[18px]">
                    File Name : {i.filename}
                  </p>
                </div>
                <div class="flex flex-wrap justify-center gap-6 pt-12">
                  <div
                    class="relative "
                    href="#"
                    onClick={() => {
                      viewFolderFile(folderId, i?._id);
                    }}
                  >
                    <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                    <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                      View
                    </span>
                  </div>
                  <div
                    class="relative "
                    href="#"
                    onClick={() => {
                      setShowModalFile(true);
                      setGetid(i?._id);
                    }}
                  >
                    <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                    <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                      Remove
                    </span>
                  </div>
                  <div
                    class="relative "
                    href="#"
                    onClick={(e) => {
                      // setGetid(i?._id);
                      e.stopPropagation(); // Prevents the row click event from being triggered
                      handleDownload(i?._id);
                    }}
                  >
                    <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                    <span class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100">
                      Download
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      );
    }
    switch (activeTab) {
      case 0:
        return <Procedures />;
      case 1:
        return <SOPs />;
      case 2:
        return <Forms />;
      // case 3:
      //   return <Records />;
      default:
        return null;
    }
  };

  const recordbuttonclick = () => {
    navigate("/records");
  };

  // new rename folder code
  const [renameData, setRenameData] = useState({});

  const onChangeRename = (e) => {
    const { name, value } = e.target;
    setRenameData({
      ...renameData,
      [name]: value,
    });
  };

  const myRenamedata = {
    foldername: renameData?.foldername,
  };

  // Rename folder submit click
  const handleRenameSubmit = async () => {
    await axiosInstanceAuth
      .post(`edit_foldername/${folderId}`, myRenamedata)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        console.log("=========myData", myData);
        if (myData?.status) {
          getFolderdata();
          setRenameFolder(false);
          toast.success(myData?.message);
        } else {
          toast.error(myData?.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Delete Folder API
  const DeleteFolderApi = async () => {
    await axiosInstanceAuth
      .get(`Delete_folder/${folderId}`)
      .then((res) => {
        const deleteFolder = decryptData(res?.data?.data);
        console.log("Delete Done --->", deleteFolder);
        if (deleteFolder.status) {
          getFolderdata();
          toast.success(deleteFolder?.message);
        } else {
          toast.error(deleteFolder?.message);
        }
        setShowModal(false);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Delete File API
  const DeleteFileApi = async () => {
    await axiosInstanceAuth
      .post(`Delete_single_file/${fileId}`, { file_id: getid })
      .then((res) => {
        const deleteFile = decryptData(res?.data?.data);
        console.log("Delete File Delete File  Delete File --->", deleteFile);
        if (deleteFile.status) {
          getFolderdata();
          toast.success(deleteFile?.message);
          getFolderFiledata();
        } else {
          toast.error(deleteFile?.message);
        }
        setShowModal(false);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  //download Single file API calling
  const handleDownload = async (id) => {
    const response = await axiosInstanceAuth.post(`Download_file/${fileId}`, {
      file_id: id,
    });

    const filePath = decryptData(response?.data?.data);
    console.log("🚀 ~ handleDownload ~ filePath:", filePath);
    const generatelink = `${BACKEND_BASE_URL}${filePath?.data?.path}`;
    console.log("🚀 ~ handleDownload ~ generatelink:", generatelink);
    fetch(generatelink) // Replace with the appropriate URL
      .then((response) => {
        console.log("🚀 ~ .then ~ response:", response);
        if (response.status) {
          return response.blob();
        } else {
          throw new Error("Failed to download PDF");
        }
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filePath?.data?.name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  const handleDownloadFolder = async () => {
    try {
      const response = await axiosInstanceAuth.get(
        `download_folder/${folderId}`,
        {
          responseType: "blob", // Set the response type to blob for binary data
        }
      );

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "application/zip" });

      // Create a link element and trigger a click to download the file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = renameNewFolder;
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <Layout>
      <div className="container">
        {/* create Folder popup  */}
        {createFolder ? (
          <>
            <div
              onClick={handleBackdropClick}
              className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center "
            >
              <div
                onClick={handlePopupClick}
                className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 "
              >
                <div>
                  <div>
                    <div className="p-5">
                      <div class="grid grid-cols-1 gap-6  lg:grid-cols-">
                        <div>
                          <label
                            className="text-[#22345C] underline font-sans font-bold text-lg"
                            for="username"
                          >
                            Folder Name :
                          </label>
                          <input
                            type="text"
                            className="block w-72 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                            name="foldername"
                            value={folder?.foldername}
                            onChange={onChangeInput}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleSubmit();
                                setCreateFolder(false);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="flex justify-center mt-5 gap-4 mb-5">
                      <div className="">
                        <button
                          onClick={() => {
                            handleSubmit();
                            setCreateFolder(false);
                          }}
                          className="bg-[#5DC90A]  px-6 py-2 leading-5  text-white font-bold  rounded-[6px]"
                        >
                          Create Folder
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {/* Rename Folder popup  */}
        {renameFolder ? (
          <>
            <div
              onClick={handleBackdropClick}
              className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center "
            >
              <div
                onClick={handlePopupClick}
                className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 "
              >
                <div>
                  <div>
                    <div className="p-5">
                      <div class="grid grid-cols-1 gap-6  lg:grid-cols-">
                        <div>
                          <label
                            className="text-[#22345C] underline font-sans font-bold text-lg"
                            for="username"
                          >
                            New Folder Name :
                          </label>
                          <input
                            type="text"
                            className="block w-72 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                            name="foldername"
                            defaultValue={renameNewFolder}
                            onChange={onChangeRename}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleRenameSubmit();
                                setRenameFolder(false);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="flex justify-center mt-5 gap-4 mb-5">
                      <div className="">
                        <button
                          onClick={() => {
                            handleRenameSubmit();
                            setRenameFolder(false);
                          }}
                          className="bg-[#5DC90A]  px-6 py-2 leading-5  text-white font-bold  rounded-[6px]"
                        >
                          Rename Folder
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {/* Delete Popup Code  */}
        {showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <span className="justify-center items-center flex">
                      <AiFillDelete className="w-16 h-16 fill-red-500" />
                    </span>
                    <p className="my-4 text-center leading-relaxed text-2xl text-red-500">
                      Are You Sure ?
                    </p>
                    <p className="my-4 text-slate-500 text-lg leading-relaxed">
                      You want to Delete this Folder
                    </p>
                  </div>

                  <div className="flex gap-2 items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b">
                    <button
                      onClick={() => setShowModal(false)}
                      class="text-red-500   font-bold py-2 px-6 rounded"
                    >
                      No
                    </button>
                    <button
                      onClick={() => {
                        DeleteFolderApi();
                        setShowModal(false);
                      }}
                      class="bg-emerald-500 active:bg-emerald-600 px-6 py-2  text-white font-bold  rounded"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}

        {/*Single file Delete Popup Code  */}
        {showModalFile ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <span className="justify-center items-center flex">
                      <AiFillDelete className="w-16 h-16 fill-red-500" />
                    </span>
                    <p className="my-4 text-center leading-relaxed text-2xl text-red-500">
                      Are You Sure ?
                    </p>
                    <p className="my-4 text-slate-500 text-lg leading-relaxed">
                      You want to Delete this File
                    </p>
                  </div>

                  <div className="flex gap-2 items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b">
                    <button
                      onClick={() => setShowModalFile(false)}
                      class="text-red-500   font-bold py-2 px-6 rounded"
                    >
                      No
                    </button>
                    <button
                      onClick={() => {
                        DeleteFileApi();
                        setShowModalFile(false);
                      }}
                      class="bg-emerald-500 active:bg-emerald-600 px-6 py-2  text-white font-bold  rounded"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}

        <div className="md:flex justify-between  mt-8">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">Templates</h1>
          </div>

          <div className="flex justify-center items-center">
            <div className="flex justify-center  items-center">
              <button
                onClick={() => setCreateFolder(true)}
                className="px-2 py-2 text-base flex items-center  w-44 mb-5  mx-2 cursor-pointer bg-[#22345C] rounded-[10px] border-gray-400"
              >
                <PiFolderSimplePlusFill size={26} className="text-[#FFFFFF]" />
                <p className="font-sans ml-2 text-xl font-medium text-[#FFFFFF]">
                  Create Folder
                </p>
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className="text-[#6F6F6F] font-medium font-sans text-xl mt-5">
            Folders
          </div>
          <div className="grid lg:grid-cols-4   grid-cols-2 gap-5 mt-5">
            <div
              className={`flex justify-between bg-[#22345C] items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                "Procedures"
              )}`}
              onClick={() => {
                handleFolderClick("Procedures");
                handleTabClick(0);
              }}
            >
              <div className="flex gap-2 items-center">
                <PiFoldersFill size={25} />
                <p className="font-sans font-medium">Procedures</p>
              </div>
            </div>
            <div
              className={`flex justify-between items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                "SOPs"
              )}`}
              onClick={() => {
                handleFolderClick("SOPs");
                handleTabClick(1);
              }}
            >
              <div className="flex gap-2 items-center">
                <PiFoldersFill size={25} />
                <p className="font-sans font-medium">SOPs</p>
              </div>
            </div>
            <div
              className={`flex justify-between items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                "Forms"
              )}`}
              onClick={() => {
                handleFolderClick("Forms");
                handleTabClick(2);
              }}
            >
              <div className="flex gap-2 items-center">
                <PiFoldersFill size={25} />
                <p className="font-sans font-medium">Forms</p>
              </div>
            </div>
            <div>
              <div
                className={`flex justify-between items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                  "Records"
                )}`}
                onClick={() => {
                  recordbuttonclick();
                  setSelectedFolder("Records");
                  // handleTabClick(3);
                }}
              >
                <div className="flex gap-2 items-center">
                  <PiFoldersFill size={25} />
                  <p className="font-sans font-medium">Records</p>
                </div>
              </div>
            </div>

            {allFolder.map((folder, index) => (
              <>
                <div
                  key={index}
                  className={`flex justify-between items-center p-5 rounded-[10px] border-gray-400 ${getFolderClass(
                    folder.foldername
                  )}`}
                  onClick={() => {
                    handleCreateFolderClick(folder.foldername, folder._id);
                  }}
                >
                  <div className="flex gap-2 items-center">
                    <PiFoldersFill size={25} />
                    <p className="font-sans font-medium">{folder.foldername}</p>
                  </div>
                  {/* <BsThreeDotsVertical size={20} className="cursor-pointer" /> */}
                  <Menu>
                    <MenuHandler>
                      <svg
                        width="4"
                        height="16"
                        viewBox="0 0 4 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="cursor-pointer"
                      >
                        <path
                          d="M7.03223e-06 2.0049C-0.00290308 0.916186 0.897777 0.00952867 1.99052 6.15717e-05C3.08473 -0.00867729 4.00723 0.914001 3.99996 2.00927C3.99268 3.10309 3.08618 4.00537 1.9978 4.00246C0.907962 4.00028 0.00291715 3.0958 7.03223e-06 2.0049Z"
                          fill="#565656"
                        />
                        <path
                          d="M1.99927 5.99829C3.08911 5.99829 3.99342 6.89985 3.99924 7.99293C4.00579 9.0882 3.08038 10.0116 1.98836 10.0007C0.895609 9.98976 -0.00507121 9.08092 2.14911e-05 7.99366C0.00511419 6.9013 0.910159 5.99829 1.99927 5.99756V5.99829Z"
                          fill="#565656"
                        />
                        <path
                          d="M2.15256e-05 14.0037C-0.00507117 12.9157 0.894154 12.0076 1.98836 11.9967C3.0811 11.985 4.00506 12.907 3.99997 14.0037C3.99488 15.0961 3.08983 15.9998 2.00072 15.9998C0.911614 15.9991 0.00511422 15.0953 2.15256e-05 14.0037Z"
                          fill="#565656"
                        />
                      </svg>
                    </MenuHandler>
                    <MenuList>
                      <MenuItem className="flex items-center gap-2">
                        <MdOutlineFileDownload size={22} />

                        <Typography
                          variant="small"
                          className="font-sans font-medium text-base"
                          onClick={() => handleDownloadFolder()}
                        >
                          Download
                        </Typography>
                      </MenuItem>
                      <MenuItem className="flex items-center gap-2">
                        <LuFolderEdit size={22} />
                        <Typography
                          variant="small"
                          className="font-sans font-medium text-base"
                          onClick={() => setRenameFolder(true)}
                        >
                          Rename
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        className="flex items-center gap-2"
                        onClick={() => setShowModal(true)}
                      >
                        <MdOutlineDelete size={22} />

                        <Typography
                          variant="small"
                          className="font-sans font-medium text-base"
                        >
                          Delete
                        </Typography>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>
              </>
            ))}
          </div>
        </div>
        <div className="">{renderTabContent()}</div>
      </div>
    </Layout>
  );
};

export default Templete;
